import React from 'react';
import { HeaderCreateActions } from './HeaderPageActions';
import { PanelPageHeader } from './PanelPageHeader';

interface PanelHeaderActionsProps {
  isSidebar: boolean;
  onClose?: () => void;
  closeAriaLabel: string;
  hasItems: boolean;
  viewSwitcher?: React.ReactNode;
  children: React.ReactNode;
}

export const PanelHeaderActions: React.FC<PanelHeaderActionsProps> = ({
  isSidebar,
  onClose,
  closeAriaLabel,
  hasItems,
  viewSwitcher,
  children,
}) => {
  return (
    <>
      {!isSidebar ? (
        <HeaderCreateActions hasItems={hasItems}>
          {hasItems ? viewSwitcher : null}
          {children}
        </HeaderCreateActions>
      ) : null}
      <PanelPageHeader
        onClose={!isSidebar ? onClose : undefined}
        closeAriaLabel={closeAriaLabel}
        endActions={
          isSidebar && hasItems ? (
            <>
              {viewSwitcher}
              {children}
            </>
          ) : undefined
        }
      />
    </>
  );
};
